import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import MediaLibrary from "@/components/admin/MediaLibrary";

export default function MediaPicker({ open, onOpenChange, accept = "any", onPick }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-4xl overflow-y-auto" data-testid="media-picker">
        <DialogHeader>
          <DialogTitle className="font-head text-2xl">Choose from library</DialogTitle>
        </DialogHeader>
        <MediaLibrary
          accept={accept}
          onSelect={(m) => {
            onPick(m.url);
            onOpenChange(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
